import { jsonp } from 'amkit3-modules/utils/ajax'
import { HUYA_WWW, HUYA_V_MAIN } from 'amkit3-modules/utils/services/urls'
import { getLogger } from 'amkit3-modules/utils/log4js'
const logger = getLogger('whitelist')
export const video_danmu_switch = cb => {
  jsonp(
    `${HUYA_WWW}/cache.php`,
    {
      m: 'WhiteListApi',
      do: 'getWhiteList',
      type: 'video_danmu_switch',
    },
    (err, data) => {
      if (err) {
        cb(err)
      } else {
        if (data.status !== 200) {
          cb(new Error(data.msg))
        } else {
          cb(null, data.data)
        }
      }
    },
    true,
    'getVideoDanmuSwitchPlayer' + Math.floor(Math.random() * 20 + 1),
  )
}

// 现场弹幕白名单
export const videoLiveDanmuAllowList = (vid, cb) => {
  jsonp(HUYA_V_MAIN, { r: 'barrage/GetVideoBarrageConfigInfo', vid: vid }, (err, data) => {
    logger.info(
      '===========================================GetVideoBarrageConfigInfo===========================:',
      data,
    )
    if (err) {
      cb(err)
    } else {
      cb(null, data)
    }
  })
}

export default {
  video_danmu_switch,
  videoLiveDanmuAllowList,
}
